// extracted by mini-css-extract-plugin
export default {"signInLink":"OnboardingSignUpPage_signInLink__CNOHF"};